import React from "react";
import { View } from "react-native";
import Skeletons from "./Skeletons";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

const LiveStreamScreenSkeleton = () => {
  const deviceSize = useDeviceSize();
  const isXL = deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE;

  if (isXL) {
    return (
      <View style={{
        flex: 0.6,
        marginVertical: 12,
        flexDirection: "column",
        backgroundColor: "#000000",
      }}>
        {/* Stream Section Skeleton */}
        <View style={{ backgroundColor: "black", paddingHorizontal: 12 }}>
          <Skeletons
            height={"calc((100vh - 120px - 55px - 24px) * 0.5)"}
            width={"100%"}
            style={{
              borderRadius: 10,
            }}
          />
        </View>

        {/* Gifting Section Skeleton */}
        <View style={{ paddingHorizontal: 12 }}>
          {/* Header skeleton */}
          <Skeletons
            height={62}
            width={"100%"}
            style={{
              borderRadius: 8,
              marginTop: 6,
            }}
          />
          {/* Gift grid skeleton */}
          <Skeletons
            height={"calc((100vh - 120px - 55px - 24px) * 0.5 - 68px)"}
            width={"100%"}
            style={{
              borderRadius: 8,
              marginTop: 6,
            }}
          />
        </View>
      </View>
    );
  }

  return (
    <View style={{
      marginHorizontal: 5,
      flex: 1,
    }}>
      {/* Stream Section Skeleton */}
      <Skeletons
        height={
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? 200
            : 400
        }
        width={"100%"}
        style={{
          borderRadius: 10,
        }}
      />

      {/* Gifting Section Skeleton */}
      <Skeletons
        height={200}
        width={"100%"}
        style={{
          borderRadius: 10,
          marginTop: 10,
        }}
      />
    </View>
  );
};

export default LiveStreamScreenSkeleton;
